$(document).ready(function(){
	// Mobile Menu
	$('.menu_icon').click(function(){
		$('.menu').slideToggle(200);

		return false
	});

	// Mobile Menu Icon
	$(document).ready(function(){
		$('#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4').click(function(){
			$(this).toggleClass('open');
		});
	});


	// Feature Carousel
$('.ie_feature_slider_contents').owlCarousel({
  loop: true,
  nav: true,
  dots: true,
  autoplay: false,
  margin: 20,
  slideBy: 1,
  dotsEach: 1,
  responsive: {
    0: {
      items: 1.1
    },
    480: {
      items: 1.3
    },
    768: {
      items: 1.3
    },
    992: {
      items: 1.7
    },
    1200: {
      items: 1.9
    },
    1400: {
      items: 2.2
    }
  }
});
	$( ".owl-prev").html('<i class="fa-solid fa-caret-left"></i>');
	$( ".owl-next").html('<i class="fa-solid fa-caret-right"></i>');


	// Testimonials Carousel
	$('.ie_testimonials').owlCarousel({
		loop:true,
		autoplay:false,
		margin: 20,
		responsive : {
		    0 : {
		        items:1.1,
				nav:true,
				dots:true,
		    },
		    480 : {
		        items:1.5,
		    },
		    768 : {
		        items:2.1,
		    },
		    992 : {
		        items:2.8,
		    },
		    1200 : {
		        items:3.5,
				nav:false,
				dots:false,
		    },
		    1400 : {
		        items:4,
		    }
		}
	});
	$( ".owl-prev").html('<i class="fa-solid fa-caret-left"></i>');
	$( ".owl-next").html('<i class="fa-solid fa-caret-right"></i>');






});